// @flow @format
import React, {Component} from 'react';
import {connect} from 'react-redux';
import Loading from '../components/Loading';
import RepositoryExplorer from '../components/RepositoryExplorer';
import {FileListBody} from '../../../components/FileList';

import type {State} from '../../../reducers';
import type {Repository} from 'lib/cloner-api';

type Props = {
	user: string,
	repositories: Repository[],
	hasMachines: boolean,
	isLoaded: boolean,
};

class RepositoryExplorerContainer extends Component<Props> {
	render() {
		const {repositories, isLoaded, user, hasMachines} = this.props;

		if (isLoaded && !hasMachines) {
			return (
				<FileListBody className="FilesLayout__Loading">
					<svg
						id="Layer_1"
						x="0px"
						y="0px"
						viewBox="0 0 496 496"
						style={{
							enableBackground: 'new 0 0 496 496',
							width: 300,
							margin: 'calc(var(--baseline) * 2)',
						}}
					>
						<path
							fill="#1BC3A5"
							d="M248,256c-39.704,0-72-32.296-72-72s32.296-72,72-72s72,32.296,72,72S287.704,256,248,256z"
						/>
						<g>
							<path
								fill="#333333"
								d="M0,40v416h496V40H0z M480,56v264H16V56H480z M16,440V336h464v104H16z"
							/>
							<rect
								x="240"
								y="144"
								fill="#333333"
								width="16"
								height="56"
							/>
							<rect
								x="240"
								y="208"
								fill="#333333"
								width="16"
								height="16"
							/>
							<rect
								x="40"
								y="360"
								fill="#333333"
								width="416"
								height="16"
							/>
							<rect
								x="88"
								y="400"
								fill="#333333"
								width="368"
								height="16"
							/>
							<polygon
								fill="#333333"
								points="437.656,109.656 448,99.312 458.344,109.656 469.656,98.344 459.312,88 469.656,77.656    458.344,66.344 448,76.688 437.656,66.344 426.344,77.656 436.688,88 426.344,98.344  "
							/>
							<rect
								x="136"
								y="176"
								fill="#333333"
								width="16"
								height="16"
							/>
							<rect
								x="104"
								y="176"
								fill="#333333"
								width="16"
								height="16"
							/>
							<rect
								x="376"
								y="176"
								fill="#333333"
								width="16"
								height="16"
							/>
							<rect
								x="344"
								y="176"
								fill="#333333"
								width="16"
								height="16"
							/>
						</g>
					</svg>
					<p style={{fontSize: 'var(--xl-text)'}}>
						<b>{user}</b>
						{' '}
						aun no registra dispositivos.
					</p>
				</FileListBody>
			);
		}

		if (!repositories) {
			return (
				<FileListBody className="FilesLayout__Loading">
					<Loading
						className="FilesLayout__Spinner"
						title={`Cargando ${isLoaded
							? 'repositorios'
							: 'dispositivos'}...`}
					/>
				</FileListBody>
			);
		}

		return <RepositoryExplorer repositories={repositories} />;
	}
}

const mapStateToProps = ({selection, session, entities}: State) => {
	const machines = entities.machines.byUser[selection.userId];

	return {
		isLoaded: !!machines,
		user: selection.userId,
		hasMachines: machines && machines.length > 0,
		repositories: entities.repositories.byMachine[selection.machineId],
	};
};

export default connect(mapStateToProps)(RepositoryExplorerContainer);



// WEBPACK FOOTER //
// ./src/routes/Explorer/containers/RepositoryExplorerContainer.js